/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthMagicRouteImport } from './routes/auth/magic'
import { Route as AuthTaskViewRouteImport } from './routes/_auth/task-view'
import { Route as AuthTaskQcRouteImport } from './routes/_auth/task-qc'
import { Route as AuthTaskListRouteImport } from './routes/_auth/task-list'
import { Route as AuthTaskRouteImport } from './routes/_auth/task'
import { Route as AuthSpacesRouteImport } from './routes/_auth/spaces'
import { Route as AuthRecentsRouteImport } from './routes/_auth/recents'
import { Route as AuthPriorityConfigRouteImport } from './routes/_auth/priority-config'
import { Route as AuthInviteRouteImport } from './routes/_auth/invite'
import { Route as AuthFeatureFlagsRouteImport } from './routes/_auth/feature-flags'
import { Route as AuthDashboardRouteImport } from './routes/_auth/dashboard'
import { Route as AuthAccountRouteImport } from './routes/_auth/account'
import { Route as AuthCompanyIdRouteImport } from './routes/_auth/$companyId'
import { Route as AuthTaskListIndexRouteImport } from './routes/_auth/task-list/index'
import { Route as AuthTaskViewTaskIdRouteImport } from './routes/_auth/task-view/$taskId'
import { Route as AuthTaskListTaskIdRouteImport } from './routes/_auth/task-list/$taskId'
import { Route as AuthSpacesSplatRouteImport } from './routes/_auth/spaces/$'
import { Route as AuthCompanyIdSpacesRouteImport } from './routes/_auth/$companyId/spaces'
import { Route as AuthCompanyIdSpacesIndexRouteImport } from './routes/_auth/$companyId/spaces/index'
import { Route as AuthCompanyIdSpacesUsersRouteImport } from './routes/_auth/$companyId/spaces/users'
import { Route as AuthCompanyIdSpacesSpaceIdRouteImport } from './routes/_auth/$companyId/spaces/$spaceId'
import { Route as AuthCompanyIdSpacesSpaceIdIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/index'
import { Route as AuthCompanyIdSpacesSpaceIdWorkbenchRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/workbench'
import { Route as AuthCompanyIdSpacesSpaceIdUsersRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/users'
import { Route as AuthCompanyIdSpacesSpaceIdTaxonomiesRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/taxonomies'
import { Route as AuthCompanyIdSpacesSpaceIdSettingsRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/settings'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects'
import { Route as AuthCompanyIdSpacesSpaceIdImportExportRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/import-export'
import { Route as AuthCompanyIdSpacesSpaceIdGuidelinesRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/guidelines'
import { Route as AuthCompanyIdSpacesSpaceIdDataAssetsRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/data-assets'
import { Route as AuthCompanyIdSpacesSpaceIdWorkbenchIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/workbench/index'
import { Route as AuthCompanyIdSpacesSpaceIdTaxonomiesIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/taxonomies/index'
import { Route as AuthCompanyIdSpacesSpaceIdSettingsIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/settings/index'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/index'
import { Route as AuthCompanyIdSpacesSpaceIdGuidelinesIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/guidelines/index'
import { Route as AuthCompanyIdSpacesSpaceIdDataAssetsIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/data-assets/index'
import { Route as AuthCompanyIdSpacesSpaceIdWorkbenchNewRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/workbench/new'
import { Route as AuthCompanyIdSpacesSpaceIdWorkbenchWorkflowIdRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/workbench/$workflowId'
import { Route as AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules'
import { Route as AuthCompanyIdSpacesSpaceIdTaxonomiesCreateRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/taxonomies/create'
import { Route as AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/taxonomies/$taxonomyId'
import { Route as AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/settings/service-accounts'
import { Route as AuthCompanyIdSpacesSpaceIdSettingsBucketMountRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/settings/bucket-mount'
import { Route as AuthCompanyIdSpacesSpaceIdSettingsApiManagementRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/settings/api-management'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId'
import { Route as AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/guidelines/$guidelineId'
import { Route as AuthCompanyIdSpacesSpaceIdDataAssetsRecentlyDeletedRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/data-assets/recently-deleted'
import { Route as AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules/index'
import { Route as AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/index'
import { Route as AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/settings/service-accounts/index'
import { Route as AuthCompanyIdSpacesSpaceIdSettingsBucketMountIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/settings/bucket-mount/index'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/index'
import { Route as AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/guidelines/$guidelineId.index'
import { Route as AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesCreateRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules/create'
import { Route as AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRuleIdRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules/$ruleId'
import { Route as AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdTaxonomyVersionIdRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/$taxonomyVersionId'
import { Route as AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsAccountIdRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/settings/service-accounts/$accountId'
import { Route as AuthCompanyIdSpacesSpaceIdSettingsBucketMountBucketIdRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/settings/bucket-mount/$bucketId'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdWorkflowRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/workflow'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/team'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdMetricsRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/metrics'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdDashboardRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/dashboard'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/index'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/index'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/index'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamScoreSettingsRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/score-settings'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/groups'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsCreateRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/create'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/work-items'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesTasksRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/tasks'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/groups.index'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/index'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesMetadataIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/metadata/index'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchIndexRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/batch/index'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsGroupIdRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/groups.$groupId'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdFormVersionIdRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/$formVersionId'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchBatchIdRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/batch/$batchId'
import { Route as AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsWorkItemIdExecutionRouteImport } from './routes/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches_/work-items_/$workItemId/execution'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthMagicRoute = AuthMagicRouteImport.update({
  id: '/auth/magic',
  path: '/auth/magic',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthTaskViewRoute = AuthTaskViewRouteImport.update({
  id: '/task-view',
  path: '/task-view',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTaskQcRoute = AuthTaskQcRouteImport.update({
  id: '/task-qc',
  path: '/task-qc',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTaskListRoute = AuthTaskListRouteImport.update({
  id: '/task-list',
  path: '/task-list',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTaskRoute = AuthTaskRouteImport.update({
  id: '/task',
  path: '/task',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSpacesRoute = AuthSpacesRouteImport.update({
  id: '/spaces',
  path: '/spaces',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRecentsRoute = AuthRecentsRouteImport.update({
  id: '/recents',
  path: '/recents',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPriorityConfigRoute = AuthPriorityConfigRouteImport.update({
  id: '/priority-config',
  path: '/priority-config',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInviteRoute = AuthInviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFeatureFlagsRoute = AuthFeatureFlagsRouteImport.update({
  id: '/feature-flags',
  path: '/feature-flags',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAccountRoute = AuthAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCompanyIdRoute = AuthCompanyIdRouteImport.update({
  id: '/$companyId',
  path: '/$companyId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTaskListIndexRoute = AuthTaskListIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthTaskListRoute,
} as any)
const AuthTaskViewTaskIdRoute = AuthTaskViewTaskIdRouteImport.update({
  id: '/$taskId',
  path: '/$taskId',
  getParentRoute: () => AuthTaskViewRoute,
} as any)
const AuthTaskListTaskIdRoute = AuthTaskListTaskIdRouteImport.update({
  id: '/$taskId',
  path: '/$taskId',
  getParentRoute: () => AuthTaskListRoute,
} as any)
const AuthSpacesSplatRoute = AuthSpacesSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthSpacesRoute,
} as any)
const AuthCompanyIdSpacesRoute = AuthCompanyIdSpacesRouteImport.update({
  id: '/spaces',
  path: '/spaces',
  getParentRoute: () => AuthCompanyIdRoute,
} as any)
const AuthCompanyIdSpacesIndexRoute =
  AuthCompanyIdSpacesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCompanyIdSpacesRoute,
  } as any)
const AuthCompanyIdSpacesUsersRoute =
  AuthCompanyIdSpacesUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthCompanyIdSpacesRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdRoute =
  AuthCompanyIdSpacesSpaceIdRouteImport.update({
    id: '/$spaceId',
    path: '/$spaceId',
    getParentRoute: () => AuthCompanyIdSpacesRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdIndexRoute =
  AuthCompanyIdSpacesSpaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdWorkbenchRoute =
  AuthCompanyIdSpacesSpaceIdWorkbenchRouteImport.update({
    id: '/workbench',
    path: '/workbench',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdUsersRoute =
  AuthCompanyIdSpacesSpaceIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdTaxonomiesRoute =
  AuthCompanyIdSpacesSpaceIdTaxonomiesRouteImport.update({
    id: '/taxonomies',
    path: '/taxonomies',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdSettingsRoute =
  AuthCompanyIdSpacesSpaceIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdProjectsRoute =
  AuthCompanyIdSpacesSpaceIdProjectsRouteImport.update({
    id: '/projects',
    path: '/projects',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdImportExportRoute =
  AuthCompanyIdSpacesSpaceIdImportExportRouteImport.update({
    id: '/import-export',
    path: '/import-export',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdGuidelinesRoute =
  AuthCompanyIdSpacesSpaceIdGuidelinesRouteImport.update({
    id: '/guidelines',
    path: '/guidelines',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdDataAssetsRoute =
  AuthCompanyIdSpacesSpaceIdDataAssetsRouteImport.update({
    id: '/data-assets',
    path: '/data-assets',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdWorkbenchIndexRoute =
  AuthCompanyIdSpacesSpaceIdWorkbenchIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdWorkbenchRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdTaxonomiesIndexRoute =
  AuthCompanyIdSpacesSpaceIdTaxonomiesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdTaxonomiesRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdSettingsIndexRoute =
  AuthCompanyIdSpacesSpaceIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdSettingsRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdProjectsIndexRoute =
  AuthCompanyIdSpacesSpaceIdProjectsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdProjectsRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdGuidelinesIndexRoute =
  AuthCompanyIdSpacesSpaceIdGuidelinesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdGuidelinesRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdDataAssetsIndexRoute =
  AuthCompanyIdSpacesSpaceIdDataAssetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdDataAssetsRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdWorkbenchNewRoute =
  AuthCompanyIdSpacesSpaceIdWorkbenchNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdWorkbenchRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdWorkbenchWorkflowIdRoute =
  AuthCompanyIdSpacesSpaceIdWorkbenchWorkflowIdRouteImport.update({
    id: '/$workflowId',
    path: '/$workflowId',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdWorkbenchRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRoute =
  AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRouteImport.update({
    id: '/validation-rules',
    path: '/validation-rules',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdTaxonomiesRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdTaxonomiesCreateRoute =
  AuthCompanyIdSpacesSpaceIdTaxonomiesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdTaxonomiesRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRoute =
  AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRouteImport.update({
    id: '/$taxonomyId',
    path: '/$taxonomyId',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdTaxonomiesRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRoute =
  AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRouteImport.update({
    id: '/service-accounts',
    path: '/service-accounts',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdSettingsRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdSettingsBucketMountRoute =
  AuthCompanyIdSpacesSpaceIdSettingsBucketMountRouteImport.update({
    id: '/bucket-mount',
    path: '/bucket-mount',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdSettingsRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdSettingsApiManagementRoute =
  AuthCompanyIdSpacesSpaceIdSettingsApiManagementRouteImport.update({
    id: '/api-management',
    path: '/api-management',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdSettingsRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdRouteImport.update({
    id: '/$projectId',
    path: '/$projectId',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdProjectsRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdRoute =
  AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdRouteImport.update({
    id: '/$guidelineId',
    path: '/$guidelineId',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdGuidelinesRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdDataAssetsRecentlyDeletedRoute =
  AuthCompanyIdSpacesSpaceIdDataAssetsRecentlyDeletedRouteImport.update({
    id: '/recently-deleted',
    path: '/recently-deleted',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdDataAssetsRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesIndexRoute =
  AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdIndexRoute =
  AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsIndexRoute =
  AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdSettingsBucketMountIndexRoute =
  AuthCompanyIdSpacesSpaceIdSettingsBucketMountIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdSettingsBucketMountRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdIndexRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdIndexRoute =
  AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesCreateRoute =
  AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRuleIdRoute =
  AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRuleIdRouteImport.update({
    id: '/$ruleId',
    path: '/$ruleId',
    getParentRoute: () =>
      AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdTaxonomyVersionIdRoute =
  AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdTaxonomyVersionIdRouteImport.update(
    {
      id: '/$taxonomyVersionId',
      path: '/$taxonomyVersionId',
      getParentRoute: () => AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRoute,
    } as any,
  )
const AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsAccountIdRoute =
  AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsAccountIdRouteImport.update({
    id: '/$accountId',
    path: '/$accountId',
    getParentRoute: () =>
      AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdSettingsBucketMountBucketIdRoute =
  AuthCompanyIdSpacesSpaceIdSettingsBucketMountBucketIdRouteImport.update({
    id: '/$bucketId',
    path: '/$bucketId',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdSettingsBucketMountRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdWorkflowRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdWorkflowRouteImport.update({
    id: '/workflow',
    path: '/workflow',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdMetricsRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdMetricsRouteImport.update({
    id: '/metrics',
    path: '/metrics',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRouteImport.update({
    id: '/forms',
    path: '/forms',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdDashboardRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRouteImport.update({
    id: '/batches',
    path: '/batches',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamIndexRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsIndexRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesIndexRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamScoreSettingsRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamScoreSettingsRouteImport.update(
    {
      id: '/score-settings',
      path: '/score-settings',
      getParentRoute: () =>
        AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRoute,
    } as any,
  )
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsCreateRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRouteImport.update({
    id: '/$formId',
    path: '/$formId',
    getParentRoute: () => AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsRouteImport.update(
    {
      id: '/work-items',
      path: '/work-items',
      getParentRoute: () =>
        AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRoute,
    } as any,
  )
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesTasksRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () =>
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsIndexRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRoute,
  } as any)
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdIndexRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRoute,
    } as any,
  )
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesMetadataIndexRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesMetadataIndexRouteImport.update(
    {
      id: '/metadata/',
      path: '/metadata/',
      getParentRoute: () =>
        AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRoute,
    } as any,
  )
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchIndexRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchIndexRouteImport.update(
    {
      id: '/batch/',
      path: '/batch/',
      getParentRoute: () =>
        AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRoute,
    } as any,
  )
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsGroupIdRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsGroupIdRouteImport.update(
    {
      id: '/$groupId',
      path: '/$groupId',
      getParentRoute: () =>
        AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRoute,
    } as any,
  )
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdFormVersionIdRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdFormVersionIdRouteImport.update(
    {
      id: '/$formVersionId',
      path: '/$formVersionId',
      getParentRoute: () =>
        AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRoute,
    } as any,
  )
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchBatchIdRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchBatchIdRouteImport.update(
    {
      id: '/batch/$batchId',
      path: '/batch/$batchId',
      getParentRoute: () =>
        AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRoute,
    } as any,
  )
const AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsWorkItemIdExecutionRoute =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsWorkItemIdExecutionRouteImport.update(
    {
      id: '/batches_/work-items_/$workItemId/execution',
      path: '/batches/work-items/$workItemId/execution',
      getParentRoute: () => AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/$companyId': typeof AuthCompanyIdRouteWithChildren
  '/account': typeof AuthAccountRoute
  '/dashboard': typeof AuthDashboardRoute
  '/feature-flags': typeof AuthFeatureFlagsRoute
  '/invite': typeof AuthInviteRoute
  '/priority-config': typeof AuthPriorityConfigRoute
  '/recents': typeof AuthRecentsRoute
  '/spaces': typeof AuthSpacesRouteWithChildren
  '/task': typeof AuthTaskRoute
  '/task-list': typeof AuthTaskListRouteWithChildren
  '/task-qc': typeof AuthTaskQcRoute
  '/task-view': typeof AuthTaskViewRouteWithChildren
  '/auth/magic': typeof AuthMagicRoute
  '/$companyId/spaces': typeof AuthCompanyIdSpacesRouteWithChildren
  '/spaces/$': typeof AuthSpacesSplatRoute
  '/task-list/$taskId': typeof AuthTaskListTaskIdRoute
  '/task-view/$taskId': typeof AuthTaskViewTaskIdRoute
  '/task-list/': typeof AuthTaskListIndexRoute
  '/$companyId/spaces/$spaceId': typeof AuthCompanyIdSpacesSpaceIdRouteWithChildren
  '/$companyId/spaces/users': typeof AuthCompanyIdSpacesUsersRoute
  '/$companyId/spaces/': typeof AuthCompanyIdSpacesIndexRoute
  '/$companyId/spaces/$spaceId/data-assets': typeof AuthCompanyIdSpacesSpaceIdDataAssetsRouteWithChildren
  '/$companyId/spaces/$spaceId/guidelines': typeof AuthCompanyIdSpacesSpaceIdGuidelinesRouteWithChildren
  '/$companyId/spaces/$spaceId/import-export': typeof AuthCompanyIdSpacesSpaceIdImportExportRoute
  '/$companyId/spaces/$spaceId/projects': typeof AuthCompanyIdSpacesSpaceIdProjectsRouteWithChildren
  '/$companyId/spaces/$spaceId/settings': typeof AuthCompanyIdSpacesSpaceIdSettingsRouteWithChildren
  '/$companyId/spaces/$spaceId/taxonomies': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesRouteWithChildren
  '/$companyId/spaces/$spaceId/users': typeof AuthCompanyIdSpacesSpaceIdUsersRoute
  '/$companyId/spaces/$spaceId/workbench': typeof AuthCompanyIdSpacesSpaceIdWorkbenchRouteWithChildren
  '/$companyId/spaces/$spaceId/': typeof AuthCompanyIdSpacesSpaceIdIndexRoute
  '/$companyId/spaces/$spaceId/data-assets/recently-deleted': typeof AuthCompanyIdSpacesSpaceIdDataAssetsRecentlyDeletedRoute
  '/$companyId/spaces/$spaceId/guidelines/$guidelineId': typeof AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdRouteWithChildren
  '/$companyId/spaces/$spaceId/projects/$projectId': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdRouteWithChildren
  '/$companyId/spaces/$spaceId/settings/api-management': typeof AuthCompanyIdSpacesSpaceIdSettingsApiManagementRoute
  '/$companyId/spaces/$spaceId/settings/bucket-mount': typeof AuthCompanyIdSpacesSpaceIdSettingsBucketMountRouteWithChildren
  '/$companyId/spaces/$spaceId/settings/service-accounts': typeof AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRouteWithChildren
  '/$companyId/spaces/$spaceId/taxonomies/$taxonomyId': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRouteWithChildren
  '/$companyId/spaces/$spaceId/taxonomies/create': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesCreateRoute
  '/$companyId/spaces/$spaceId/taxonomies/validation-rules': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRouteWithChildren
  '/$companyId/spaces/$spaceId/workbench/$workflowId': typeof AuthCompanyIdSpacesSpaceIdWorkbenchWorkflowIdRoute
  '/$companyId/spaces/$spaceId/workbench/new': typeof AuthCompanyIdSpacesSpaceIdWorkbenchNewRoute
  '/$companyId/spaces/$spaceId/data-assets/': typeof AuthCompanyIdSpacesSpaceIdDataAssetsIndexRoute
  '/$companyId/spaces/$spaceId/guidelines/': typeof AuthCompanyIdSpacesSpaceIdGuidelinesIndexRoute
  '/$companyId/spaces/$spaceId/projects/': typeof AuthCompanyIdSpacesSpaceIdProjectsIndexRoute
  '/$companyId/spaces/$spaceId/settings/': typeof AuthCompanyIdSpacesSpaceIdSettingsIndexRoute
  '/$companyId/spaces/$spaceId/taxonomies/': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesIndexRoute
  '/$companyId/spaces/$spaceId/workbench/': typeof AuthCompanyIdSpacesSpaceIdWorkbenchIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/batches': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRouteWithChildren
  '/$companyId/spaces/$spaceId/projects/$projectId/dashboard': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdDashboardRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/forms': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRouteWithChildren
  '/$companyId/spaces/$spaceId/projects/$projectId/metrics': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdMetricsRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/team': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRouteWithChildren
  '/$companyId/spaces/$spaceId/projects/$projectId/workflow': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdWorkflowRoute
  '/$companyId/spaces/$spaceId/settings/bucket-mount/$bucketId': typeof AuthCompanyIdSpacesSpaceIdSettingsBucketMountBucketIdRoute
  '/$companyId/spaces/$spaceId/settings/service-accounts/$accountId': typeof AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsAccountIdRoute
  '/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/$taxonomyVersionId': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdTaxonomyVersionIdRoute
  '/$companyId/spaces/$spaceId/taxonomies/validation-rules/$ruleId': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRuleIdRoute
  '/$companyId/spaces/$spaceId/taxonomies/validation-rules/create': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesCreateRoute
  '/$companyId/spaces/$spaceId/guidelines/$guidelineId/': typeof AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdIndexRoute
  '/$companyId/spaces/$spaceId/settings/bucket-mount/': typeof AuthCompanyIdSpacesSpaceIdSettingsBucketMountIndexRoute
  '/$companyId/spaces/$spaceId/settings/service-accounts/': typeof AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsIndexRoute
  '/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdIndexRoute
  '/$companyId/spaces/$spaceId/taxonomies/validation-rules/': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/batches/tasks': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesTasksRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/batches/work-items': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRouteWithChildren
  '/$companyId/spaces/$spaceId/projects/$projectId/forms/create': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsCreateRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/team/groups': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRouteWithChildren
  '/$companyId/spaces/$spaceId/projects/$projectId/team/score-settings': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamScoreSettingsRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/batches/': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/forms/': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/team/': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/batches/batch/$batchId': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchBatchIdRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/$formVersionId': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdFormVersionIdRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/team/groups/$groupId': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsGroupIdRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/batches/batch': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/batches/metadata': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesMetadataIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/team/groups/': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/batches/work-items/$workItemId/execution': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsWorkItemIdExecutionRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/$companyId': typeof AuthCompanyIdRouteWithChildren
  '/account': typeof AuthAccountRoute
  '/dashboard': typeof AuthDashboardRoute
  '/feature-flags': typeof AuthFeatureFlagsRoute
  '/invite': typeof AuthInviteRoute
  '/priority-config': typeof AuthPriorityConfigRoute
  '/recents': typeof AuthRecentsRoute
  '/spaces': typeof AuthSpacesRouteWithChildren
  '/task': typeof AuthTaskRoute
  '/task-qc': typeof AuthTaskQcRoute
  '/task-view': typeof AuthTaskViewRouteWithChildren
  '/auth/magic': typeof AuthMagicRoute
  '/spaces/$': typeof AuthSpacesSplatRoute
  '/task-list/$taskId': typeof AuthTaskListTaskIdRoute
  '/task-view/$taskId': typeof AuthTaskViewTaskIdRoute
  '/task-list': typeof AuthTaskListIndexRoute
  '/$companyId/spaces/users': typeof AuthCompanyIdSpacesUsersRoute
  '/$companyId/spaces': typeof AuthCompanyIdSpacesIndexRoute
  '/$companyId/spaces/$spaceId/import-export': typeof AuthCompanyIdSpacesSpaceIdImportExportRoute
  '/$companyId/spaces/$spaceId/users': typeof AuthCompanyIdSpacesSpaceIdUsersRoute
  '/$companyId/spaces/$spaceId': typeof AuthCompanyIdSpacesSpaceIdIndexRoute
  '/$companyId/spaces/$spaceId/data-assets/recently-deleted': typeof AuthCompanyIdSpacesSpaceIdDataAssetsRecentlyDeletedRoute
  '/$companyId/spaces/$spaceId/settings/api-management': typeof AuthCompanyIdSpacesSpaceIdSettingsApiManagementRoute
  '/$companyId/spaces/$spaceId/taxonomies/create': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesCreateRoute
  '/$companyId/spaces/$spaceId/workbench/$workflowId': typeof AuthCompanyIdSpacesSpaceIdWorkbenchWorkflowIdRoute
  '/$companyId/spaces/$spaceId/workbench/new': typeof AuthCompanyIdSpacesSpaceIdWorkbenchNewRoute
  '/$companyId/spaces/$spaceId/data-assets': typeof AuthCompanyIdSpacesSpaceIdDataAssetsIndexRoute
  '/$companyId/spaces/$spaceId/guidelines': typeof AuthCompanyIdSpacesSpaceIdGuidelinesIndexRoute
  '/$companyId/spaces/$spaceId/projects': typeof AuthCompanyIdSpacesSpaceIdProjectsIndexRoute
  '/$companyId/spaces/$spaceId/settings': typeof AuthCompanyIdSpacesSpaceIdSettingsIndexRoute
  '/$companyId/spaces/$spaceId/taxonomies': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesIndexRoute
  '/$companyId/spaces/$spaceId/workbench': typeof AuthCompanyIdSpacesSpaceIdWorkbenchIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/dashboard': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdDashboardRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/metrics': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdMetricsRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/workflow': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdWorkflowRoute
  '/$companyId/spaces/$spaceId/settings/bucket-mount/$bucketId': typeof AuthCompanyIdSpacesSpaceIdSettingsBucketMountBucketIdRoute
  '/$companyId/spaces/$spaceId/settings/service-accounts/$accountId': typeof AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsAccountIdRoute
  '/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/$taxonomyVersionId': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdTaxonomyVersionIdRoute
  '/$companyId/spaces/$spaceId/taxonomies/validation-rules/$ruleId': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRuleIdRoute
  '/$companyId/spaces/$spaceId/taxonomies/validation-rules/create': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesCreateRoute
  '/$companyId/spaces/$spaceId/guidelines/$guidelineId': typeof AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdIndexRoute
  '/$companyId/spaces/$spaceId/settings/bucket-mount': typeof AuthCompanyIdSpacesSpaceIdSettingsBucketMountIndexRoute
  '/$companyId/spaces/$spaceId/settings/service-accounts': typeof AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsIndexRoute
  '/$companyId/spaces/$spaceId/taxonomies/$taxonomyId': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdIndexRoute
  '/$companyId/spaces/$spaceId/taxonomies/validation-rules': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/batches/tasks': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesTasksRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/batches/work-items': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/forms/create': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsCreateRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/team/score-settings': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamScoreSettingsRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/batches': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/forms': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/team': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/batches/batch/$batchId': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchBatchIdRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/$formVersionId': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdFormVersionIdRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/team/groups/$groupId': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsGroupIdRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/batches/batch': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/batches/metadata': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesMetadataIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/team/groups': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsIndexRoute
  '/$companyId/spaces/$spaceId/projects/$projectId/batches/work-items/$workItemId/execution': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsWorkItemIdExecutionRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/$companyId': typeof AuthCompanyIdRouteWithChildren
  '/_auth/account': typeof AuthAccountRoute
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/feature-flags': typeof AuthFeatureFlagsRoute
  '/_auth/invite': typeof AuthInviteRoute
  '/_auth/priority-config': typeof AuthPriorityConfigRoute
  '/_auth/recents': typeof AuthRecentsRoute
  '/_auth/spaces': typeof AuthSpacesRouteWithChildren
  '/_auth/task': typeof AuthTaskRoute
  '/_auth/task-list': typeof AuthTaskListRouteWithChildren
  '/_auth/task-qc': typeof AuthTaskQcRoute
  '/_auth/task-view': typeof AuthTaskViewRouteWithChildren
  '/auth/magic': typeof AuthMagicRoute
  '/_auth/$companyId/spaces': typeof AuthCompanyIdSpacesRouteWithChildren
  '/_auth/spaces/$': typeof AuthSpacesSplatRoute
  '/_auth/task-list/$taskId': typeof AuthTaskListTaskIdRoute
  '/_auth/task-view/$taskId': typeof AuthTaskViewTaskIdRoute
  '/_auth/task-list/': typeof AuthTaskListIndexRoute
  '/_auth/$companyId/spaces/$spaceId': typeof AuthCompanyIdSpacesSpaceIdRouteWithChildren
  '/_auth/$companyId/spaces/users': typeof AuthCompanyIdSpacesUsersRoute
  '/_auth/$companyId/spaces/': typeof AuthCompanyIdSpacesIndexRoute
  '/_auth/$companyId/spaces/$spaceId/data-assets': typeof AuthCompanyIdSpacesSpaceIdDataAssetsRouteWithChildren
  '/_auth/$companyId/spaces/$spaceId/guidelines': typeof AuthCompanyIdSpacesSpaceIdGuidelinesRouteWithChildren
  '/_auth/$companyId/spaces/$spaceId/import-export': typeof AuthCompanyIdSpacesSpaceIdImportExportRoute
  '/_auth/$companyId/spaces/$spaceId/projects': typeof AuthCompanyIdSpacesSpaceIdProjectsRouteWithChildren
  '/_auth/$companyId/spaces/$spaceId/settings': typeof AuthCompanyIdSpacesSpaceIdSettingsRouteWithChildren
  '/_auth/$companyId/spaces/$spaceId/taxonomies': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesRouteWithChildren
  '/_auth/$companyId/spaces/$spaceId/users': typeof AuthCompanyIdSpacesSpaceIdUsersRoute
  '/_auth/$companyId/spaces/$spaceId/workbench': typeof AuthCompanyIdSpacesSpaceIdWorkbenchRouteWithChildren
  '/_auth/$companyId/spaces/$spaceId/': typeof AuthCompanyIdSpacesSpaceIdIndexRoute
  '/_auth/$companyId/spaces/$spaceId/data-assets/recently-deleted': typeof AuthCompanyIdSpacesSpaceIdDataAssetsRecentlyDeletedRoute
  '/_auth/$companyId/spaces/$spaceId/guidelines/$guidelineId': typeof AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdRouteWithChildren
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdRouteWithChildren
  '/_auth/$companyId/spaces/$spaceId/settings/api-management': typeof AuthCompanyIdSpacesSpaceIdSettingsApiManagementRoute
  '/_auth/$companyId/spaces/$spaceId/settings/bucket-mount': typeof AuthCompanyIdSpacesSpaceIdSettingsBucketMountRouteWithChildren
  '/_auth/$companyId/spaces/$spaceId/settings/service-accounts': typeof AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRouteWithChildren
  '/_auth/$companyId/spaces/$spaceId/taxonomies/$taxonomyId': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRouteWithChildren
  '/_auth/$companyId/spaces/$spaceId/taxonomies/create': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesCreateRoute
  '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRouteWithChildren
  '/_auth/$companyId/spaces/$spaceId/workbench/$workflowId': typeof AuthCompanyIdSpacesSpaceIdWorkbenchWorkflowIdRoute
  '/_auth/$companyId/spaces/$spaceId/workbench/new': typeof AuthCompanyIdSpacesSpaceIdWorkbenchNewRoute
  '/_auth/$companyId/spaces/$spaceId/data-assets/': typeof AuthCompanyIdSpacesSpaceIdDataAssetsIndexRoute
  '/_auth/$companyId/spaces/$spaceId/guidelines/': typeof AuthCompanyIdSpacesSpaceIdGuidelinesIndexRoute
  '/_auth/$companyId/spaces/$spaceId/projects/': typeof AuthCompanyIdSpacesSpaceIdProjectsIndexRoute
  '/_auth/$companyId/spaces/$spaceId/settings/': typeof AuthCompanyIdSpacesSpaceIdSettingsIndexRoute
  '/_auth/$companyId/spaces/$spaceId/taxonomies/': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesIndexRoute
  '/_auth/$companyId/spaces/$spaceId/workbench/': typeof AuthCompanyIdSpacesSpaceIdWorkbenchIndexRoute
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRouteWithChildren
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/dashboard': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdDashboardRoute
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRouteWithChildren
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/metrics': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdMetricsRoute
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRouteWithChildren
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/workflow': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdWorkflowRoute
  '/_auth/$companyId/spaces/$spaceId/settings/bucket-mount/$bucketId': typeof AuthCompanyIdSpacesSpaceIdSettingsBucketMountBucketIdRoute
  '/_auth/$companyId/spaces/$spaceId/settings/service-accounts/$accountId': typeof AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsAccountIdRoute
  '/_auth/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/$taxonomyVersionId': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdTaxonomyVersionIdRoute
  '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules/$ruleId': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRuleIdRoute
  '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules/create': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesCreateRoute
  '/_auth/$companyId/spaces/$spaceId/guidelines/$guidelineId/': typeof AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdIndexRoute
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdIndexRoute
  '/_auth/$companyId/spaces/$spaceId/settings/bucket-mount/': typeof AuthCompanyIdSpacesSpaceIdSettingsBucketMountIndexRoute
  '/_auth/$companyId/spaces/$spaceId/settings/service-accounts/': typeof AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsIndexRoute
  '/_auth/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdIndexRoute
  '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules/': typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesIndexRoute
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/tasks': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesTasksRoute
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/work-items': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsRoute
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRouteWithChildren
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/create': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsCreateRoute
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/groups': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRouteWithChildren
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/score-settings': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamScoreSettingsRoute
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesIndexRoute
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsIndexRoute
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamIndexRoute
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/batch/$batchId': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchBatchIdRoute
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/$formVersionId': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdFormVersionIdRoute
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/groups/$groupId': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsGroupIdRoute
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/batch/': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchIndexRoute
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/metadata/': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesMetadataIndexRoute
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdIndexRoute
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/groups/': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsIndexRoute
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches_/work-items_/$workItemId/execution': typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsWorkItemIdExecutionRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/$companyId'
    | '/account'
    | '/dashboard'
    | '/feature-flags'
    | '/invite'
    | '/priority-config'
    | '/recents'
    | '/spaces'
    | '/task'
    | '/task-list'
    | '/task-qc'
    | '/task-view'
    | '/auth/magic'
    | '/$companyId/spaces'
    | '/spaces/$'
    | '/task-list/$taskId'
    | '/task-view/$taskId'
    | '/task-list/'
    | '/$companyId/spaces/$spaceId'
    | '/$companyId/spaces/users'
    | '/$companyId/spaces/'
    | '/$companyId/spaces/$spaceId/data-assets'
    | '/$companyId/spaces/$spaceId/guidelines'
    | '/$companyId/spaces/$spaceId/import-export'
    | '/$companyId/spaces/$spaceId/projects'
    | '/$companyId/spaces/$spaceId/settings'
    | '/$companyId/spaces/$spaceId/taxonomies'
    | '/$companyId/spaces/$spaceId/users'
    | '/$companyId/spaces/$spaceId/workbench'
    | '/$companyId/spaces/$spaceId/'
    | '/$companyId/spaces/$spaceId/data-assets/recently-deleted'
    | '/$companyId/spaces/$spaceId/guidelines/$guidelineId'
    | '/$companyId/spaces/$spaceId/projects/$projectId'
    | '/$companyId/spaces/$spaceId/settings/api-management'
    | '/$companyId/spaces/$spaceId/settings/bucket-mount'
    | '/$companyId/spaces/$spaceId/settings/service-accounts'
    | '/$companyId/spaces/$spaceId/taxonomies/$taxonomyId'
    | '/$companyId/spaces/$spaceId/taxonomies/create'
    | '/$companyId/spaces/$spaceId/taxonomies/validation-rules'
    | '/$companyId/spaces/$spaceId/workbench/$workflowId'
    | '/$companyId/spaces/$spaceId/workbench/new'
    | '/$companyId/spaces/$spaceId/data-assets/'
    | '/$companyId/spaces/$spaceId/guidelines/'
    | '/$companyId/spaces/$spaceId/projects/'
    | '/$companyId/spaces/$spaceId/settings/'
    | '/$companyId/spaces/$spaceId/taxonomies/'
    | '/$companyId/spaces/$spaceId/workbench/'
    | '/$companyId/spaces/$spaceId/projects/$projectId/batches'
    | '/$companyId/spaces/$spaceId/projects/$projectId/dashboard'
    | '/$companyId/spaces/$spaceId/projects/$projectId/forms'
    | '/$companyId/spaces/$spaceId/projects/$projectId/metrics'
    | '/$companyId/spaces/$spaceId/projects/$projectId/team'
    | '/$companyId/spaces/$spaceId/projects/$projectId/workflow'
    | '/$companyId/spaces/$spaceId/settings/bucket-mount/$bucketId'
    | '/$companyId/spaces/$spaceId/settings/service-accounts/$accountId'
    | '/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/$taxonomyVersionId'
    | '/$companyId/spaces/$spaceId/taxonomies/validation-rules/$ruleId'
    | '/$companyId/spaces/$spaceId/taxonomies/validation-rules/create'
    | '/$companyId/spaces/$spaceId/guidelines/$guidelineId/'
    | '/$companyId/spaces/$spaceId/projects/$projectId/'
    | '/$companyId/spaces/$spaceId/settings/bucket-mount/'
    | '/$companyId/spaces/$spaceId/settings/service-accounts/'
    | '/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/'
    | '/$companyId/spaces/$spaceId/taxonomies/validation-rules/'
    | '/$companyId/spaces/$spaceId/projects/$projectId/batches/tasks'
    | '/$companyId/spaces/$spaceId/projects/$projectId/batches/work-items'
    | '/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId'
    | '/$companyId/spaces/$spaceId/projects/$projectId/forms/create'
    | '/$companyId/spaces/$spaceId/projects/$projectId/team/groups'
    | '/$companyId/spaces/$spaceId/projects/$projectId/team/score-settings'
    | '/$companyId/spaces/$spaceId/projects/$projectId/batches/'
    | '/$companyId/spaces/$spaceId/projects/$projectId/forms/'
    | '/$companyId/spaces/$spaceId/projects/$projectId/team/'
    | '/$companyId/spaces/$spaceId/projects/$projectId/batches/batch/$batchId'
    | '/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/$formVersionId'
    | '/$companyId/spaces/$spaceId/projects/$projectId/team/groups/$groupId'
    | '/$companyId/spaces/$spaceId/projects/$projectId/batches/batch'
    | '/$companyId/spaces/$spaceId/projects/$projectId/batches/metadata'
    | '/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/'
    | '/$companyId/spaces/$spaceId/projects/$projectId/team/groups/'
    | '/$companyId/spaces/$spaceId/projects/$projectId/batches/work-items/$workItemId/execution'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/$companyId'
    | '/account'
    | '/dashboard'
    | '/feature-flags'
    | '/invite'
    | '/priority-config'
    | '/recents'
    | '/spaces'
    | '/task'
    | '/task-qc'
    | '/task-view'
    | '/auth/magic'
    | '/spaces/$'
    | '/task-list/$taskId'
    | '/task-view/$taskId'
    | '/task-list'
    | '/$companyId/spaces/users'
    | '/$companyId/spaces'
    | '/$companyId/spaces/$spaceId/import-export'
    | '/$companyId/spaces/$spaceId/users'
    | '/$companyId/spaces/$spaceId'
    | '/$companyId/spaces/$spaceId/data-assets/recently-deleted'
    | '/$companyId/spaces/$spaceId/settings/api-management'
    | '/$companyId/spaces/$spaceId/taxonomies/create'
    | '/$companyId/spaces/$spaceId/workbench/$workflowId'
    | '/$companyId/spaces/$spaceId/workbench/new'
    | '/$companyId/spaces/$spaceId/data-assets'
    | '/$companyId/spaces/$spaceId/guidelines'
    | '/$companyId/spaces/$spaceId/projects'
    | '/$companyId/spaces/$spaceId/settings'
    | '/$companyId/spaces/$spaceId/taxonomies'
    | '/$companyId/spaces/$spaceId/workbench'
    | '/$companyId/spaces/$spaceId/projects/$projectId/dashboard'
    | '/$companyId/spaces/$spaceId/projects/$projectId/metrics'
    | '/$companyId/spaces/$spaceId/projects/$projectId/workflow'
    | '/$companyId/spaces/$spaceId/settings/bucket-mount/$bucketId'
    | '/$companyId/spaces/$spaceId/settings/service-accounts/$accountId'
    | '/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/$taxonomyVersionId'
    | '/$companyId/spaces/$spaceId/taxonomies/validation-rules/$ruleId'
    | '/$companyId/spaces/$spaceId/taxonomies/validation-rules/create'
    | '/$companyId/spaces/$spaceId/guidelines/$guidelineId'
    | '/$companyId/spaces/$spaceId/projects/$projectId'
    | '/$companyId/spaces/$spaceId/settings/bucket-mount'
    | '/$companyId/spaces/$spaceId/settings/service-accounts'
    | '/$companyId/spaces/$spaceId/taxonomies/$taxonomyId'
    | '/$companyId/spaces/$spaceId/taxonomies/validation-rules'
    | '/$companyId/spaces/$spaceId/projects/$projectId/batches/tasks'
    | '/$companyId/spaces/$spaceId/projects/$projectId/batches/work-items'
    | '/$companyId/spaces/$spaceId/projects/$projectId/forms/create'
    | '/$companyId/spaces/$spaceId/projects/$projectId/team/score-settings'
    | '/$companyId/spaces/$spaceId/projects/$projectId/batches'
    | '/$companyId/spaces/$spaceId/projects/$projectId/forms'
    | '/$companyId/spaces/$spaceId/projects/$projectId/team'
    | '/$companyId/spaces/$spaceId/projects/$projectId/batches/batch/$batchId'
    | '/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/$formVersionId'
    | '/$companyId/spaces/$spaceId/projects/$projectId/team/groups/$groupId'
    | '/$companyId/spaces/$spaceId/projects/$projectId/batches/batch'
    | '/$companyId/spaces/$spaceId/projects/$projectId/batches/metadata'
    | '/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId'
    | '/$companyId/spaces/$spaceId/projects/$projectId/team/groups'
    | '/$companyId/spaces/$spaceId/projects/$projectId/batches/work-items/$workItemId/execution'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/_auth/$companyId'
    | '/_auth/account'
    | '/_auth/dashboard'
    | '/_auth/feature-flags'
    | '/_auth/invite'
    | '/_auth/priority-config'
    | '/_auth/recents'
    | '/_auth/spaces'
    | '/_auth/task'
    | '/_auth/task-list'
    | '/_auth/task-qc'
    | '/_auth/task-view'
    | '/auth/magic'
    | '/_auth/$companyId/spaces'
    | '/_auth/spaces/$'
    | '/_auth/task-list/$taskId'
    | '/_auth/task-view/$taskId'
    | '/_auth/task-list/'
    | '/_auth/$companyId/spaces/$spaceId'
    | '/_auth/$companyId/spaces/users'
    | '/_auth/$companyId/spaces/'
    | '/_auth/$companyId/spaces/$spaceId/data-assets'
    | '/_auth/$companyId/spaces/$spaceId/guidelines'
    | '/_auth/$companyId/spaces/$spaceId/import-export'
    | '/_auth/$companyId/spaces/$spaceId/projects'
    | '/_auth/$companyId/spaces/$spaceId/settings'
    | '/_auth/$companyId/spaces/$spaceId/taxonomies'
    | '/_auth/$companyId/spaces/$spaceId/users'
    | '/_auth/$companyId/spaces/$spaceId/workbench'
    | '/_auth/$companyId/spaces/$spaceId/'
    | '/_auth/$companyId/spaces/$spaceId/data-assets/recently-deleted'
    | '/_auth/$companyId/spaces/$spaceId/guidelines/$guidelineId'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId'
    | '/_auth/$companyId/spaces/$spaceId/settings/api-management'
    | '/_auth/$companyId/spaces/$spaceId/settings/bucket-mount'
    | '/_auth/$companyId/spaces/$spaceId/settings/service-accounts'
    | '/_auth/$companyId/spaces/$spaceId/taxonomies/$taxonomyId'
    | '/_auth/$companyId/spaces/$spaceId/taxonomies/create'
    | '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules'
    | '/_auth/$companyId/spaces/$spaceId/workbench/$workflowId'
    | '/_auth/$companyId/spaces/$spaceId/workbench/new'
    | '/_auth/$companyId/spaces/$spaceId/data-assets/'
    | '/_auth/$companyId/spaces/$spaceId/guidelines/'
    | '/_auth/$companyId/spaces/$spaceId/projects/'
    | '/_auth/$companyId/spaces/$spaceId/settings/'
    | '/_auth/$companyId/spaces/$spaceId/taxonomies/'
    | '/_auth/$companyId/spaces/$spaceId/workbench/'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/dashboard'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/metrics'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/workflow'
    | '/_auth/$companyId/spaces/$spaceId/settings/bucket-mount/$bucketId'
    | '/_auth/$companyId/spaces/$spaceId/settings/service-accounts/$accountId'
    | '/_auth/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/$taxonomyVersionId'
    | '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules/$ruleId'
    | '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules/create'
    | '/_auth/$companyId/spaces/$spaceId/guidelines/$guidelineId/'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/'
    | '/_auth/$companyId/spaces/$spaceId/settings/bucket-mount/'
    | '/_auth/$companyId/spaces/$spaceId/settings/service-accounts/'
    | '/_auth/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/'
    | '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules/'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/tasks'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/work-items'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/create'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/groups'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/score-settings'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/batch/$batchId'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/$formVersionId'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/groups/$groupId'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/batch/'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/metadata/'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/groups/'
    | '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches_/work-items_/$workItemId/execution'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthMagicRoute: typeof AuthMagicRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/magic': {
      id: '/auth/magic'
      path: '/auth/magic'
      fullPath: '/auth/magic'
      preLoaderRoute: typeof AuthMagicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/task-view': {
      id: '/_auth/task-view'
      path: '/task-view'
      fullPath: '/task-view'
      preLoaderRoute: typeof AuthTaskViewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/task-qc': {
      id: '/_auth/task-qc'
      path: '/task-qc'
      fullPath: '/task-qc'
      preLoaderRoute: typeof AuthTaskQcRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/task-list': {
      id: '/_auth/task-list'
      path: '/task-list'
      fullPath: '/task-list'
      preLoaderRoute: typeof AuthTaskListRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/task': {
      id: '/_auth/task'
      path: '/task'
      fullPath: '/task'
      preLoaderRoute: typeof AuthTaskRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/spaces': {
      id: '/_auth/spaces'
      path: '/spaces'
      fullPath: '/spaces'
      preLoaderRoute: typeof AuthSpacesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/recents': {
      id: '/_auth/recents'
      path: '/recents'
      fullPath: '/recents'
      preLoaderRoute: typeof AuthRecentsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/priority-config': {
      id: '/_auth/priority-config'
      path: '/priority-config'
      fullPath: '/priority-config'
      preLoaderRoute: typeof AuthPriorityConfigRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invite': {
      id: '/_auth/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof AuthInviteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/feature-flags': {
      id: '/_auth/feature-flags'
      path: '/feature-flags'
      fullPath: '/feature-flags'
      preLoaderRoute: typeof AuthFeatureFlagsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/account': {
      id: '/_auth/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthAccountRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/$companyId': {
      id: '/_auth/$companyId'
      path: '/$companyId'
      fullPath: '/$companyId'
      preLoaderRoute: typeof AuthCompanyIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/task-list/': {
      id: '/_auth/task-list/'
      path: '/'
      fullPath: '/task-list/'
      preLoaderRoute: typeof AuthTaskListIndexRouteImport
      parentRoute: typeof AuthTaskListRoute
    }
    '/_auth/task-view/$taskId': {
      id: '/_auth/task-view/$taskId'
      path: '/$taskId'
      fullPath: '/task-view/$taskId'
      preLoaderRoute: typeof AuthTaskViewTaskIdRouteImport
      parentRoute: typeof AuthTaskViewRoute
    }
    '/_auth/task-list/$taskId': {
      id: '/_auth/task-list/$taskId'
      path: '/$taskId'
      fullPath: '/task-list/$taskId'
      preLoaderRoute: typeof AuthTaskListTaskIdRouteImport
      parentRoute: typeof AuthTaskListRoute
    }
    '/_auth/spaces/$': {
      id: '/_auth/spaces/$'
      path: '/$'
      fullPath: '/spaces/$'
      preLoaderRoute: typeof AuthSpacesSplatRouteImport
      parentRoute: typeof AuthSpacesRoute
    }
    '/_auth/$companyId/spaces': {
      id: '/_auth/$companyId/spaces'
      path: '/spaces'
      fullPath: '/$companyId/spaces'
      preLoaderRoute: typeof AuthCompanyIdSpacesRouteImport
      parentRoute: typeof AuthCompanyIdRoute
    }
    '/_auth/$companyId/spaces/': {
      id: '/_auth/$companyId/spaces/'
      path: '/'
      fullPath: '/$companyId/spaces/'
      preLoaderRoute: typeof AuthCompanyIdSpacesIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesRoute
    }
    '/_auth/$companyId/spaces/users': {
      id: '/_auth/$companyId/spaces/users'
      path: '/users'
      fullPath: '/$companyId/spaces/users'
      preLoaderRoute: typeof AuthCompanyIdSpacesUsersRouteImport
      parentRoute: typeof AuthCompanyIdSpacesRoute
    }
    '/_auth/$companyId/spaces/$spaceId': {
      id: '/_auth/$companyId/spaces/$spaceId'
      path: '/$spaceId'
      fullPath: '/$companyId/spaces/$spaceId'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdRouteImport
      parentRoute: typeof AuthCompanyIdSpacesRoute
    }
    '/_auth/$companyId/spaces/$spaceId/': {
      id: '/_auth/$companyId/spaces/$spaceId/'
      path: '/'
      fullPath: '/$companyId/spaces/$spaceId/'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/workbench': {
      id: '/_auth/$companyId/spaces/$spaceId/workbench'
      path: '/workbench'
      fullPath: '/$companyId/spaces/$spaceId/workbench'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdWorkbenchRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/users': {
      id: '/_auth/$companyId/spaces/$spaceId/users'
      path: '/users'
      fullPath: '/$companyId/spaces/$spaceId/users'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdUsersRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/taxonomies': {
      id: '/_auth/$companyId/spaces/$spaceId/taxonomies'
      path: '/taxonomies'
      fullPath: '/$companyId/spaces/$spaceId/taxonomies'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/settings': {
      id: '/_auth/$companyId/spaces/$spaceId/settings'
      path: '/settings'
      fullPath: '/$companyId/spaces/$spaceId/settings'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects': {
      id: '/_auth/$companyId/spaces/$spaceId/projects'
      path: '/projects'
      fullPath: '/$companyId/spaces/$spaceId/projects'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/import-export': {
      id: '/_auth/$companyId/spaces/$spaceId/import-export'
      path: '/import-export'
      fullPath: '/$companyId/spaces/$spaceId/import-export'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdImportExportRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/guidelines': {
      id: '/_auth/$companyId/spaces/$spaceId/guidelines'
      path: '/guidelines'
      fullPath: '/$companyId/spaces/$spaceId/guidelines'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdGuidelinesRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/data-assets': {
      id: '/_auth/$companyId/spaces/$spaceId/data-assets'
      path: '/data-assets'
      fullPath: '/$companyId/spaces/$spaceId/data-assets'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdDataAssetsRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/workbench/': {
      id: '/_auth/$companyId/spaces/$spaceId/workbench/'
      path: '/'
      fullPath: '/$companyId/spaces/$spaceId/workbench/'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdWorkbenchIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdWorkbenchRoute
    }
    '/_auth/$companyId/spaces/$spaceId/taxonomies/': {
      id: '/_auth/$companyId/spaces/$spaceId/taxonomies/'
      path: '/'
      fullPath: '/$companyId/spaces/$spaceId/taxonomies/'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesRoute
    }
    '/_auth/$companyId/spaces/$spaceId/settings/': {
      id: '/_auth/$companyId/spaces/$spaceId/settings/'
      path: '/'
      fullPath: '/$companyId/spaces/$spaceId/settings/'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/'
      path: '/'
      fullPath: '/$companyId/spaces/$spaceId/projects/'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsRoute
    }
    '/_auth/$companyId/spaces/$spaceId/guidelines/': {
      id: '/_auth/$companyId/spaces/$spaceId/guidelines/'
      path: '/'
      fullPath: '/$companyId/spaces/$spaceId/guidelines/'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdGuidelinesIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdGuidelinesRoute
    }
    '/_auth/$companyId/spaces/$spaceId/data-assets/': {
      id: '/_auth/$companyId/spaces/$spaceId/data-assets/'
      path: '/'
      fullPath: '/$companyId/spaces/$spaceId/data-assets/'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdDataAssetsIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdDataAssetsRoute
    }
    '/_auth/$companyId/spaces/$spaceId/workbench/new': {
      id: '/_auth/$companyId/spaces/$spaceId/workbench/new'
      path: '/new'
      fullPath: '/$companyId/spaces/$spaceId/workbench/new'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdWorkbenchNewRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdWorkbenchRoute
    }
    '/_auth/$companyId/spaces/$spaceId/workbench/$workflowId': {
      id: '/_auth/$companyId/spaces/$spaceId/workbench/$workflowId'
      path: '/$workflowId'
      fullPath: '/$companyId/spaces/$spaceId/workbench/$workflowId'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdWorkbenchWorkflowIdRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdWorkbenchRoute
    }
    '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules': {
      id: '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules'
      path: '/validation-rules'
      fullPath: '/$companyId/spaces/$spaceId/taxonomies/validation-rules'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesRoute
    }
    '/_auth/$companyId/spaces/$spaceId/taxonomies/create': {
      id: '/_auth/$companyId/spaces/$spaceId/taxonomies/create'
      path: '/create'
      fullPath: '/$companyId/spaces/$spaceId/taxonomies/create'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesCreateRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesRoute
    }
    '/_auth/$companyId/spaces/$spaceId/taxonomies/$taxonomyId': {
      id: '/_auth/$companyId/spaces/$spaceId/taxonomies/$taxonomyId'
      path: '/$taxonomyId'
      fullPath: '/$companyId/spaces/$spaceId/taxonomies/$taxonomyId'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesRoute
    }
    '/_auth/$companyId/spaces/$spaceId/settings/service-accounts': {
      id: '/_auth/$companyId/spaces/$spaceId/settings/service-accounts'
      path: '/service-accounts'
      fullPath: '/$companyId/spaces/$spaceId/settings/service-accounts'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsRoute
    }
    '/_auth/$companyId/spaces/$spaceId/settings/bucket-mount': {
      id: '/_auth/$companyId/spaces/$spaceId/settings/bucket-mount'
      path: '/bucket-mount'
      fullPath: '/$companyId/spaces/$spaceId/settings/bucket-mount'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsBucketMountRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsRoute
    }
    '/_auth/$companyId/spaces/$spaceId/settings/api-management': {
      id: '/_auth/$companyId/spaces/$spaceId/settings/api-management'
      path: '/api-management'
      fullPath: '/$companyId/spaces/$spaceId/settings/api-management'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsApiManagementRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId'
      path: '/$projectId'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsRoute
    }
    '/_auth/$companyId/spaces/$spaceId/guidelines/$guidelineId': {
      id: '/_auth/$companyId/spaces/$spaceId/guidelines/$guidelineId'
      path: '/$guidelineId'
      fullPath: '/$companyId/spaces/$spaceId/guidelines/$guidelineId'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdGuidelinesRoute
    }
    '/_auth/$companyId/spaces/$spaceId/data-assets/recently-deleted': {
      id: '/_auth/$companyId/spaces/$spaceId/data-assets/recently-deleted'
      path: '/recently-deleted'
      fullPath: '/$companyId/spaces/$spaceId/data-assets/recently-deleted'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdDataAssetsRecentlyDeletedRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdDataAssetsRoute
    }
    '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules/': {
      id: '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules/'
      path: '/'
      fullPath: '/$companyId/spaces/$spaceId/taxonomies/validation-rules/'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRoute
    }
    '/_auth/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/': {
      id: '/_auth/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/'
      path: '/'
      fullPath: '/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/settings/service-accounts/': {
      id: '/_auth/$companyId/spaces/$spaceId/settings/service-accounts/'
      path: '/'
      fullPath: '/$companyId/spaces/$spaceId/settings/service-accounts/'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRoute
    }
    '/_auth/$companyId/spaces/$spaceId/settings/bucket-mount/': {
      id: '/_auth/$companyId/spaces/$spaceId/settings/bucket-mount/'
      path: '/'
      fullPath: '/$companyId/spaces/$spaceId/settings/bucket-mount/'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsBucketMountIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsBucketMountRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/'
      path: '/'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/guidelines/$guidelineId/': {
      id: '/_auth/$companyId/spaces/$spaceId/guidelines/$guidelineId/'
      path: '/'
      fullPath: '/$companyId/spaces/$spaceId/guidelines/$guidelineId/'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules/create': {
      id: '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules/create'
      path: '/create'
      fullPath: '/$companyId/spaces/$spaceId/taxonomies/validation-rules/create'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesCreateRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRoute
    }
    '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules/$ruleId': {
      id: '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules/$ruleId'
      path: '/$ruleId'
      fullPath: '/$companyId/spaces/$spaceId/taxonomies/validation-rules/$ruleId'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRuleIdRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRoute
    }
    '/_auth/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/$taxonomyVersionId': {
      id: '/_auth/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/$taxonomyVersionId'
      path: '/$taxonomyVersionId'
      fullPath: '/$companyId/spaces/$spaceId/taxonomies/$taxonomyId/$taxonomyVersionId'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdTaxonomyVersionIdRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/settings/service-accounts/$accountId': {
      id: '/_auth/$companyId/spaces/$spaceId/settings/service-accounts/$accountId'
      path: '/$accountId'
      fullPath: '/$companyId/spaces/$spaceId/settings/service-accounts/$accountId'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsAccountIdRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRoute
    }
    '/_auth/$companyId/spaces/$spaceId/settings/bucket-mount/$bucketId': {
      id: '/_auth/$companyId/spaces/$spaceId/settings/bucket-mount/$bucketId'
      path: '/$bucketId'
      fullPath: '/$companyId/spaces/$spaceId/settings/bucket-mount/$bucketId'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsBucketMountBucketIdRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsBucketMountRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/workflow': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/workflow'
      path: '/workflow'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/workflow'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdWorkflowRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team'
      path: '/team'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/team'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/metrics': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/metrics'
      path: '/metrics'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/metrics'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdMetricsRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms'
      path: '/forms'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/forms'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/dashboard': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/dashboard'
      path: '/dashboard'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/dashboard'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdDashboardRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches'
      path: '/batches'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/batches'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/'
      path: '/'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/team/'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/'
      path: '/'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/forms/'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/'
      path: '/'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/batches/'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/score-settings': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/score-settings'
      path: '/score-settings'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/team/score-settings'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamScoreSettingsRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/groups': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/groups'
      path: '/groups'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/team/groups'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/create': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/create'
      path: '/create'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/forms/create'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsCreateRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId'
      path: '/$formId'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/work-items': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/work-items'
      path: '/work-items'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/batches/work-items'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/tasks': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/tasks'
      path: '/tasks'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/batches/tasks'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesTasksRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/groups/': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/groups/'
      path: '/'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/team/groups/'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/'
      path: '/'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/metadata/': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/metadata/'
      path: '/metadata'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/batches/metadata'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesMetadataIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/batch/': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/batch/'
      path: '/batch'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/batches/batch'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchIndexRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/groups/$groupId': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/groups/$groupId'
      path: '/$groupId'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/team/groups/$groupId'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsGroupIdRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/$formVersionId': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/$formVersionId'
      path: '/$formVersionId'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/forms/$formId/$formVersionId'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdFormVersionIdRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/batch/$batchId': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/batch/$batchId'
      path: '/batch/$batchId'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/batches/batch/$batchId'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchBatchIdRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRoute
    }
    '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches_/work-items_/$workItemId/execution': {
      id: '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches_/work-items_/$workItemId/execution'
      path: '/batches/work-items/$workItemId/execution'
      fullPath: '/$companyId/spaces/$spaceId/projects/$projectId/batches/work-items/$workItemId/execution'
      preLoaderRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsWorkItemIdExecutionRouteImport
      parentRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute
    }
  }
}

interface AuthCompanyIdSpacesSpaceIdDataAssetsRouteChildren {
  AuthCompanyIdSpacesSpaceIdDataAssetsRecentlyDeletedRoute: typeof AuthCompanyIdSpacesSpaceIdDataAssetsRecentlyDeletedRoute
  AuthCompanyIdSpacesSpaceIdDataAssetsIndexRoute: typeof AuthCompanyIdSpacesSpaceIdDataAssetsIndexRoute
}

const AuthCompanyIdSpacesSpaceIdDataAssetsRouteChildren: AuthCompanyIdSpacesSpaceIdDataAssetsRouteChildren =
  {
    AuthCompanyIdSpacesSpaceIdDataAssetsRecentlyDeletedRoute:
      AuthCompanyIdSpacesSpaceIdDataAssetsRecentlyDeletedRoute,
    AuthCompanyIdSpacesSpaceIdDataAssetsIndexRoute:
      AuthCompanyIdSpacesSpaceIdDataAssetsIndexRoute,
  }

const AuthCompanyIdSpacesSpaceIdDataAssetsRouteWithChildren =
  AuthCompanyIdSpacesSpaceIdDataAssetsRoute._addFileChildren(
    AuthCompanyIdSpacesSpaceIdDataAssetsRouteChildren,
  )

interface AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdRouteChildren {
  AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdIndexRoute: typeof AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdIndexRoute
}

const AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdRouteChildren: AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdRouteChildren =
  {
    AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdIndexRoute:
      AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdIndexRoute,
  }

const AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdRouteWithChildren =
  AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdRoute._addFileChildren(
    AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdRouteChildren,
  )

interface AuthCompanyIdSpacesSpaceIdGuidelinesRouteChildren {
  AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdRoute: typeof AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdRouteWithChildren
  AuthCompanyIdSpacesSpaceIdGuidelinesIndexRoute: typeof AuthCompanyIdSpacesSpaceIdGuidelinesIndexRoute
}

const AuthCompanyIdSpacesSpaceIdGuidelinesRouteChildren: AuthCompanyIdSpacesSpaceIdGuidelinesRouteChildren =
  {
    AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdRoute:
      AuthCompanyIdSpacesSpaceIdGuidelinesGuidelineIdRouteWithChildren,
    AuthCompanyIdSpacesSpaceIdGuidelinesIndexRoute:
      AuthCompanyIdSpacesSpaceIdGuidelinesIndexRoute,
  }

const AuthCompanyIdSpacesSpaceIdGuidelinesRouteWithChildren =
  AuthCompanyIdSpacesSpaceIdGuidelinesRoute._addFileChildren(
    AuthCompanyIdSpacesSpaceIdGuidelinesRouteChildren,
  )

interface AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRouteChildren {
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesTasksRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesTasksRoute
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsRoute
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesIndexRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesIndexRoute
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchBatchIdRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchBatchIdRoute
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchIndexRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchIndexRoute
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesMetadataIndexRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesMetadataIndexRoute
}

const AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRouteChildren: AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRouteChildren =
  {
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesTasksRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesTasksRoute,
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsRoute,
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesIndexRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesIndexRoute,
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchBatchIdRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchBatchIdRoute,
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchIndexRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesBatchIndexRoute,
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesMetadataIndexRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesMetadataIndexRoute,
  }

const AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRouteWithChildren =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRoute._addFileChildren(
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRouteChildren,
  )

interface AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRouteChildren {
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdFormVersionIdRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdFormVersionIdRoute
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdIndexRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdIndexRoute
}

const AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRouteChildren: AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRouteChildren =
  {
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdFormVersionIdRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdFormVersionIdRoute,
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdIndexRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdIndexRoute,
  }

const AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRouteWithChildren =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRoute._addFileChildren(
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRouteChildren,
  )

interface AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRouteChildren {
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRouteWithChildren
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsCreateRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsCreateRoute
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsIndexRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsIndexRoute
}

const AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRouteChildren: AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRouteChildren =
  {
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsFormIdRouteWithChildren,
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsCreateRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsCreateRoute,
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsIndexRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsIndexRoute,
  }

const AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRouteWithChildren =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRoute._addFileChildren(
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRouteChildren,
  )

interface AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRouteChildren {
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsGroupIdRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsGroupIdRoute
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsIndexRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsIndexRoute
}

const AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRouteChildren: AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRouteChildren =
  {
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsGroupIdRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsGroupIdRoute,
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsIndexRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsIndexRoute,
  }

const AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRouteWithChildren =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRoute._addFileChildren(
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRouteChildren,
  )

interface AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRouteChildren {
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRouteWithChildren
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamScoreSettingsRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamScoreSettingsRoute
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamIndexRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamIndexRoute
}

const AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRouteChildren: AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRouteChildren =
  {
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamGroupsRouteWithChildren,
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamScoreSettingsRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamScoreSettingsRoute,
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamIndexRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamIndexRoute,
  }

const AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRouteWithChildren =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRoute._addFileChildren(
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRouteChildren,
  )

interface AuthCompanyIdSpacesSpaceIdProjectsProjectIdRouteChildren {
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRouteWithChildren
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdDashboardRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdDashboardRoute
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRouteWithChildren
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdMetricsRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdMetricsRoute
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRouteWithChildren
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdWorkflowRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdWorkflowRoute
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdIndexRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdIndexRoute
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsWorkItemIdExecutionRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsWorkItemIdExecutionRoute
}

const AuthCompanyIdSpacesSpaceIdProjectsProjectIdRouteChildren: AuthCompanyIdSpacesSpaceIdProjectsProjectIdRouteChildren =
  {
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesRouteWithChildren,
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdDashboardRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdDashboardRoute,
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdFormsRouteWithChildren,
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdMetricsRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdMetricsRoute,
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdTeamRouteWithChildren,
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdWorkflowRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdWorkflowRoute,
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdIndexRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdIndexRoute,
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsWorkItemIdExecutionRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdBatchesWorkItemsWorkItemIdExecutionRoute,
  }

const AuthCompanyIdSpacesSpaceIdProjectsProjectIdRouteWithChildren =
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute._addFileChildren(
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdRouteChildren,
  )

interface AuthCompanyIdSpacesSpaceIdProjectsRouteChildren {
  AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsProjectIdRouteWithChildren
  AuthCompanyIdSpacesSpaceIdProjectsIndexRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsIndexRoute
}

const AuthCompanyIdSpacesSpaceIdProjectsRouteChildren: AuthCompanyIdSpacesSpaceIdProjectsRouteChildren =
  {
    AuthCompanyIdSpacesSpaceIdProjectsProjectIdRoute:
      AuthCompanyIdSpacesSpaceIdProjectsProjectIdRouteWithChildren,
    AuthCompanyIdSpacesSpaceIdProjectsIndexRoute:
      AuthCompanyIdSpacesSpaceIdProjectsIndexRoute,
  }

const AuthCompanyIdSpacesSpaceIdProjectsRouteWithChildren =
  AuthCompanyIdSpacesSpaceIdProjectsRoute._addFileChildren(
    AuthCompanyIdSpacesSpaceIdProjectsRouteChildren,
  )

interface AuthCompanyIdSpacesSpaceIdSettingsBucketMountRouteChildren {
  AuthCompanyIdSpacesSpaceIdSettingsBucketMountBucketIdRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsBucketMountBucketIdRoute
  AuthCompanyIdSpacesSpaceIdSettingsBucketMountIndexRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsBucketMountIndexRoute
}

const AuthCompanyIdSpacesSpaceIdSettingsBucketMountRouteChildren: AuthCompanyIdSpacesSpaceIdSettingsBucketMountRouteChildren =
  {
    AuthCompanyIdSpacesSpaceIdSettingsBucketMountBucketIdRoute:
      AuthCompanyIdSpacesSpaceIdSettingsBucketMountBucketIdRoute,
    AuthCompanyIdSpacesSpaceIdSettingsBucketMountIndexRoute:
      AuthCompanyIdSpacesSpaceIdSettingsBucketMountIndexRoute,
  }

const AuthCompanyIdSpacesSpaceIdSettingsBucketMountRouteWithChildren =
  AuthCompanyIdSpacesSpaceIdSettingsBucketMountRoute._addFileChildren(
    AuthCompanyIdSpacesSpaceIdSettingsBucketMountRouteChildren,
  )

interface AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRouteChildren {
  AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsAccountIdRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsAccountIdRoute
  AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsIndexRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsIndexRoute
}

const AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRouteChildren: AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRouteChildren =
  {
    AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsAccountIdRoute:
      AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsAccountIdRoute,
    AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsIndexRoute:
      AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsIndexRoute,
  }

const AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRouteWithChildren =
  AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRoute._addFileChildren(
    AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRouteChildren,
  )

interface AuthCompanyIdSpacesSpaceIdSettingsRouteChildren {
  AuthCompanyIdSpacesSpaceIdSettingsApiManagementRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsApiManagementRoute
  AuthCompanyIdSpacesSpaceIdSettingsBucketMountRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsBucketMountRouteWithChildren
  AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRouteWithChildren
  AuthCompanyIdSpacesSpaceIdSettingsIndexRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsIndexRoute
}

const AuthCompanyIdSpacesSpaceIdSettingsRouteChildren: AuthCompanyIdSpacesSpaceIdSettingsRouteChildren =
  {
    AuthCompanyIdSpacesSpaceIdSettingsApiManagementRoute:
      AuthCompanyIdSpacesSpaceIdSettingsApiManagementRoute,
    AuthCompanyIdSpacesSpaceIdSettingsBucketMountRoute:
      AuthCompanyIdSpacesSpaceIdSettingsBucketMountRouteWithChildren,
    AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRoute:
      AuthCompanyIdSpacesSpaceIdSettingsServiceAccountsRouteWithChildren,
    AuthCompanyIdSpacesSpaceIdSettingsIndexRoute:
      AuthCompanyIdSpacesSpaceIdSettingsIndexRoute,
  }

const AuthCompanyIdSpacesSpaceIdSettingsRouteWithChildren =
  AuthCompanyIdSpacesSpaceIdSettingsRoute._addFileChildren(
    AuthCompanyIdSpacesSpaceIdSettingsRouteChildren,
  )

interface AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRouteChildren {
  AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdTaxonomyVersionIdRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdTaxonomyVersionIdRoute
  AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdIndexRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdIndexRoute
}

const AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRouteChildren: AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRouteChildren =
  {
    AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdTaxonomyVersionIdRoute:
      AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdTaxonomyVersionIdRoute,
    AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdIndexRoute:
      AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdIndexRoute,
  }

const AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRouteWithChildren =
  AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRoute._addFileChildren(
    AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRouteChildren,
  )

interface AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRouteChildren {
  AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRuleIdRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRuleIdRoute
  AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesCreateRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesCreateRoute
  AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesIndexRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesIndexRoute
}

const AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRouteChildren: AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRouteChildren =
  {
    AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRuleIdRoute:
      AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRuleIdRoute,
    AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesCreateRoute:
      AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesCreateRoute,
    AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesIndexRoute:
      AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesIndexRoute,
  }

const AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRouteWithChildren =
  AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRoute._addFileChildren(
    AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRouteChildren,
  )

interface AuthCompanyIdSpacesSpaceIdTaxonomiesRouteChildren {
  AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRouteWithChildren
  AuthCompanyIdSpacesSpaceIdTaxonomiesCreateRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesCreateRoute
  AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRouteWithChildren
  AuthCompanyIdSpacesSpaceIdTaxonomiesIndexRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesIndexRoute
}

const AuthCompanyIdSpacesSpaceIdTaxonomiesRouteChildren: AuthCompanyIdSpacesSpaceIdTaxonomiesRouteChildren =
  {
    AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRoute:
      AuthCompanyIdSpacesSpaceIdTaxonomiesTaxonomyIdRouteWithChildren,
    AuthCompanyIdSpacesSpaceIdTaxonomiesCreateRoute:
      AuthCompanyIdSpacesSpaceIdTaxonomiesCreateRoute,
    AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRoute:
      AuthCompanyIdSpacesSpaceIdTaxonomiesValidationRulesRouteWithChildren,
    AuthCompanyIdSpacesSpaceIdTaxonomiesIndexRoute:
      AuthCompanyIdSpacesSpaceIdTaxonomiesIndexRoute,
  }

const AuthCompanyIdSpacesSpaceIdTaxonomiesRouteWithChildren =
  AuthCompanyIdSpacesSpaceIdTaxonomiesRoute._addFileChildren(
    AuthCompanyIdSpacesSpaceIdTaxonomiesRouteChildren,
  )

interface AuthCompanyIdSpacesSpaceIdWorkbenchRouteChildren {
  AuthCompanyIdSpacesSpaceIdWorkbenchWorkflowIdRoute: typeof AuthCompanyIdSpacesSpaceIdWorkbenchWorkflowIdRoute
  AuthCompanyIdSpacesSpaceIdWorkbenchNewRoute: typeof AuthCompanyIdSpacesSpaceIdWorkbenchNewRoute
  AuthCompanyIdSpacesSpaceIdWorkbenchIndexRoute: typeof AuthCompanyIdSpacesSpaceIdWorkbenchIndexRoute
}

const AuthCompanyIdSpacesSpaceIdWorkbenchRouteChildren: AuthCompanyIdSpacesSpaceIdWorkbenchRouteChildren =
  {
    AuthCompanyIdSpacesSpaceIdWorkbenchWorkflowIdRoute:
      AuthCompanyIdSpacesSpaceIdWorkbenchWorkflowIdRoute,
    AuthCompanyIdSpacesSpaceIdWorkbenchNewRoute:
      AuthCompanyIdSpacesSpaceIdWorkbenchNewRoute,
    AuthCompanyIdSpacesSpaceIdWorkbenchIndexRoute:
      AuthCompanyIdSpacesSpaceIdWorkbenchIndexRoute,
  }

const AuthCompanyIdSpacesSpaceIdWorkbenchRouteWithChildren =
  AuthCompanyIdSpacesSpaceIdWorkbenchRoute._addFileChildren(
    AuthCompanyIdSpacesSpaceIdWorkbenchRouteChildren,
  )

interface AuthCompanyIdSpacesSpaceIdRouteChildren {
  AuthCompanyIdSpacesSpaceIdDataAssetsRoute: typeof AuthCompanyIdSpacesSpaceIdDataAssetsRouteWithChildren
  AuthCompanyIdSpacesSpaceIdGuidelinesRoute: typeof AuthCompanyIdSpacesSpaceIdGuidelinesRouteWithChildren
  AuthCompanyIdSpacesSpaceIdImportExportRoute: typeof AuthCompanyIdSpacesSpaceIdImportExportRoute
  AuthCompanyIdSpacesSpaceIdProjectsRoute: typeof AuthCompanyIdSpacesSpaceIdProjectsRouteWithChildren
  AuthCompanyIdSpacesSpaceIdSettingsRoute: typeof AuthCompanyIdSpacesSpaceIdSettingsRouteWithChildren
  AuthCompanyIdSpacesSpaceIdTaxonomiesRoute: typeof AuthCompanyIdSpacesSpaceIdTaxonomiesRouteWithChildren
  AuthCompanyIdSpacesSpaceIdUsersRoute: typeof AuthCompanyIdSpacesSpaceIdUsersRoute
  AuthCompanyIdSpacesSpaceIdWorkbenchRoute: typeof AuthCompanyIdSpacesSpaceIdWorkbenchRouteWithChildren
  AuthCompanyIdSpacesSpaceIdIndexRoute: typeof AuthCompanyIdSpacesSpaceIdIndexRoute
}

const AuthCompanyIdSpacesSpaceIdRouteChildren: AuthCompanyIdSpacesSpaceIdRouteChildren =
  {
    AuthCompanyIdSpacesSpaceIdDataAssetsRoute:
      AuthCompanyIdSpacesSpaceIdDataAssetsRouteWithChildren,
    AuthCompanyIdSpacesSpaceIdGuidelinesRoute:
      AuthCompanyIdSpacesSpaceIdGuidelinesRouteWithChildren,
    AuthCompanyIdSpacesSpaceIdImportExportRoute:
      AuthCompanyIdSpacesSpaceIdImportExportRoute,
    AuthCompanyIdSpacesSpaceIdProjectsRoute:
      AuthCompanyIdSpacesSpaceIdProjectsRouteWithChildren,
    AuthCompanyIdSpacesSpaceIdSettingsRoute:
      AuthCompanyIdSpacesSpaceIdSettingsRouteWithChildren,
    AuthCompanyIdSpacesSpaceIdTaxonomiesRoute:
      AuthCompanyIdSpacesSpaceIdTaxonomiesRouteWithChildren,
    AuthCompanyIdSpacesSpaceIdUsersRoute: AuthCompanyIdSpacesSpaceIdUsersRoute,
    AuthCompanyIdSpacesSpaceIdWorkbenchRoute:
      AuthCompanyIdSpacesSpaceIdWorkbenchRouteWithChildren,
    AuthCompanyIdSpacesSpaceIdIndexRoute: AuthCompanyIdSpacesSpaceIdIndexRoute,
  }

const AuthCompanyIdSpacesSpaceIdRouteWithChildren =
  AuthCompanyIdSpacesSpaceIdRoute._addFileChildren(
    AuthCompanyIdSpacesSpaceIdRouteChildren,
  )

interface AuthCompanyIdSpacesRouteChildren {
  AuthCompanyIdSpacesSpaceIdRoute: typeof AuthCompanyIdSpacesSpaceIdRouteWithChildren
  AuthCompanyIdSpacesUsersRoute: typeof AuthCompanyIdSpacesUsersRoute
  AuthCompanyIdSpacesIndexRoute: typeof AuthCompanyIdSpacesIndexRoute
}

const AuthCompanyIdSpacesRouteChildren: AuthCompanyIdSpacesRouteChildren = {
  AuthCompanyIdSpacesSpaceIdRoute: AuthCompanyIdSpacesSpaceIdRouteWithChildren,
  AuthCompanyIdSpacesUsersRoute: AuthCompanyIdSpacesUsersRoute,
  AuthCompanyIdSpacesIndexRoute: AuthCompanyIdSpacesIndexRoute,
}

const AuthCompanyIdSpacesRouteWithChildren =
  AuthCompanyIdSpacesRoute._addFileChildren(AuthCompanyIdSpacesRouteChildren)

interface AuthCompanyIdRouteChildren {
  AuthCompanyIdSpacesRoute: typeof AuthCompanyIdSpacesRouteWithChildren
}

const AuthCompanyIdRouteChildren: AuthCompanyIdRouteChildren = {
  AuthCompanyIdSpacesRoute: AuthCompanyIdSpacesRouteWithChildren,
}

const AuthCompanyIdRouteWithChildren = AuthCompanyIdRoute._addFileChildren(
  AuthCompanyIdRouteChildren,
)

interface AuthSpacesRouteChildren {
  AuthSpacesSplatRoute: typeof AuthSpacesSplatRoute
}

const AuthSpacesRouteChildren: AuthSpacesRouteChildren = {
  AuthSpacesSplatRoute: AuthSpacesSplatRoute,
}

const AuthSpacesRouteWithChildren = AuthSpacesRoute._addFileChildren(
  AuthSpacesRouteChildren,
)

interface AuthTaskListRouteChildren {
  AuthTaskListTaskIdRoute: typeof AuthTaskListTaskIdRoute
  AuthTaskListIndexRoute: typeof AuthTaskListIndexRoute
}

const AuthTaskListRouteChildren: AuthTaskListRouteChildren = {
  AuthTaskListTaskIdRoute: AuthTaskListTaskIdRoute,
  AuthTaskListIndexRoute: AuthTaskListIndexRoute,
}

const AuthTaskListRouteWithChildren = AuthTaskListRoute._addFileChildren(
  AuthTaskListRouteChildren,
)

interface AuthTaskViewRouteChildren {
  AuthTaskViewTaskIdRoute: typeof AuthTaskViewTaskIdRoute
}

const AuthTaskViewRouteChildren: AuthTaskViewRouteChildren = {
  AuthTaskViewTaskIdRoute: AuthTaskViewTaskIdRoute,
}

const AuthTaskViewRouteWithChildren = AuthTaskViewRoute._addFileChildren(
  AuthTaskViewRouteChildren,
)

interface AuthRouteChildren {
  AuthCompanyIdRoute: typeof AuthCompanyIdRouteWithChildren
  AuthAccountRoute: typeof AuthAccountRoute
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthFeatureFlagsRoute: typeof AuthFeatureFlagsRoute
  AuthInviteRoute: typeof AuthInviteRoute
  AuthPriorityConfigRoute: typeof AuthPriorityConfigRoute
  AuthRecentsRoute: typeof AuthRecentsRoute
  AuthSpacesRoute: typeof AuthSpacesRouteWithChildren
  AuthTaskRoute: typeof AuthTaskRoute
  AuthTaskListRoute: typeof AuthTaskListRouteWithChildren
  AuthTaskQcRoute: typeof AuthTaskQcRoute
  AuthTaskViewRoute: typeof AuthTaskViewRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCompanyIdRoute: AuthCompanyIdRouteWithChildren,
  AuthAccountRoute: AuthAccountRoute,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthFeatureFlagsRoute: AuthFeatureFlagsRoute,
  AuthInviteRoute: AuthInviteRoute,
  AuthPriorityConfigRoute: AuthPriorityConfigRoute,
  AuthRecentsRoute: AuthRecentsRoute,
  AuthSpacesRoute: AuthSpacesRouteWithChildren,
  AuthTaskRoute: AuthTaskRoute,
  AuthTaskListRoute: AuthTaskListRouteWithChildren,
  AuthTaskQcRoute: AuthTaskQcRoute,
  AuthTaskViewRoute: AuthTaskViewRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthMagicRoute: AuthMagicRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
